export const CategoriesTableColumns = [
    // { id: 'serial', labelEn: '#', labelAr: '#', align: 'start' },
    { id: 'nameEn', labelEn: 'English Name', labelAr: 'الاسم بالتنسيق الإنجليزي', align: 'start' },
    { id: 'nameAr', labelEn: 'Arabic Name', labelAr: 'الاسم بالتنسيق العربي', align: 'start' },
    { id: 'slug', labelEn: 'Slug', labelAr: 'الاسم المعرف (Slug)', align: 'start' },
    { id: 'department', labelEn: 'Department', labelAr: 'القطاع', align: 'start' },
    { id: 'parent', labelEn: 'Parent', labelAr: 'الفئة الأب', align: 'start' },
    { id: 'is_active', labelEn: 'Status', labelAr: 'الحالة', align: 'center' },
    { id: 'created_at', labelEn: 'Created At', labelAr: 'تاريخ الإضافة', align: 'start' },
];
